import {
  getOrgRoles,
  createRole,
  updateRole,
  delRole,
  setRolePermission
} from '@/api/sys.role'
import {
  getAllAuths,
  getRoleAuth
} from '@/api/sys.auth'

export default {
  namespaced: true,
  actions: {
    /**
     * 分页查询
     */
    searchRoles ({
      dispatch
    }, {
      vm,
      data
    }) {
      return getOrgRoles(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
     * @description 新增角色
     * @param {Object} param context
     * @param {Object} param vm {Object} vue 实例
     * @param {Object} param data {Object} 数据
     */
    createRole ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求新增角色接口
      return createRole(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
     *
     * 更新角色
     * @param {*} param1
     */
    updateRole ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求更新角色接口
      return updateRole(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
     *删除角色
     * @param {*} param0
     * @param {*} param1
     */
    delRole ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求删除角色接口
      delRole(data)
        .then(res => {
          vm.loading.close()
          vm.roles(vm.pageable.page, vm.pageable.per_page)
          vm.$alert('角色删除成功', '操作提示', {
            confirmButtonText: '确定'
          })
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    },
    /**
     * 请求所有菜单接口
     * @param {*} param0
     * @param {*} param1
     */
    getAllAuths ({
      dispatch
    }, {
      vm
    }) {
      // 开始请求所有菜单接口
      getAllAuths()
        .then(res => {
          vm.authData = res.data
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    /**
     *获取角色菜单
     * @param {*} param0
     * @param {*} param1
     */
    getRoleAuth ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求获取角色菜单
      return getRoleAuth(data)
        .then(res => {
          return res
        })
        .catch(err => {
          console.log('err: ', err)
        })
    },
    /**
     * 设置角色权限
     * @param {*} param0
     * @param {*} param1
     */
    setRolePermission ({
      dispatch
    }, {
      vm,
      data
    }) {
      // 开始请求新增墓型接口

      return setRolePermission(data)
        .then(res => {
          return res
        })
        .catch(err => {
          vm.loading.close()
          console.log('err: ', err)
        })
    }
  }
}
